import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { useIsVisualEditorPreview } from '../../../../hooks/useIsVisualEditorPreview';
import { selectAdvertisingPageCategory } from '../../../../utils/advertising/selectAdvertisingPageCategory';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import SiteSection from '../../../layouts/SiteLayout/SiteSection/SiteSection';
import Advertising from '../../../shared/Advertising/Advertising';
import { Helmet } from 'react-helmet';
import { InformaMetaTagPageType } from '../../../../constants';

const Prompt = loadable(() =>
  import(/* webpackChunkName: "Prompt" */ '../../../sections/Prompt/Prompt'),
);

const HomeHeroBanner = loadable(() =>
  import(
    /* webpackChunkName: "HomeHeroBanner" */ '../../../styled/siteBuilderModules/HeroBannerModule'
  ),
);

export function HomeView(props) {
  const {
    siteContent: { data: { sections = [] } = {} } = {},
    siteHeader: { data: { homeHeaderStyle, homeHeroBanner } = {} } = {},
    options: { data: { brand: { whiteLogo, logoSize } = {} } = {} } = {},
    pageCategory,
  } = props;

  const isVisualEditor = useIsVisualEditorPreview();
  const middleIndex = Math.floor(sections.length / 2);

  return (
    <SiteLayout>
      <Helmet>
        <meta name="informa-page-id" content="home" />
        <meta
          name="informa-page-type"
          content={InformaMetaTagPageType.BasePage}
        />
      </Helmet>
      {homeHeaderStyle === 'TRANSPARENT_WITHOUT_HEADER' && !isVisualEditor && (
        <HomeHeroBanner
          section={homeHeroBanner}
          brandLogo={whiteLogo?.path}
          brandLogoSize={logoSize}
        />
      )}
      <Prompt>
        {sections.map((section, index) => (
          <Fragment key={section.id}>
            <SiteSection section={section} index={index} />
            {index === middleIndex && (
              <Advertising
                key="ads"
                advSlots={[{ slotId: '728_2' }]}
                advSize="728_90"
                pageCategory={pageCategory}
              />
            )}
          </Fragment>
        ))}
      </Prompt>
    </SiteLayout>
  );
}

HomeView.propTypes = {
  siteContent: PropTypes.shape({
    data: PropTypes.shape({
      sections: PropTypes.arrayOf(PropTypes.object),
      valueProposition: PropTypes.string,
      subTitle: PropTypes.string,
      text: PropTypes.string,
    }),
    meta: PropTypes.shape({
      description: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    siteContent: state.siteContent,
    siteHeader: state.siteHeader,
    options: state.options,
    pageCategory: selectAdvertisingPageCategory(state),
  };
}

export default connect(mapStateToProps)(HomeView);
